import {identity, uniqBy} from 'lodash-es';

export const replaceItem = <T, R>(items: T[], item: T, selector: (item: T) => R): T[] => {
    const existing = items.findIndex(it => selector(it) === selector(item));
    return existing !== -1 ? replaceAt(items, item, existing) : items;
};

export const replaceOrAdd = <T, R>(items: T[], item: T, selector: (item: T) => R): T[] => {
    const existing = items.findIndex(it => selector(it) === selector(item));
    return existing !== -1 ? replaceAt(items, item, existing) : [...items, item];
};

export const replaceAt = <T>(items: T[], item: T, at: number): T[] =>
    items.map((it, index) => (index === at ? item : it));

export function containsDuplicates<T, R>(
    elements: ArrayLike<T>,
    selector?: (element: T) => R,
): boolean {
    return uniqBy(elements, selector ?? identity).length !== elements.length;
}

export const filterNotNullish = <T>(arr: Array<T>): Array<T> => arr.filter(item => item != null);

export function toggleInSet<T>(items: ReadonlySet<T>, item: T): Set<T> {
    const next = new Set(items);
    if (next.has(item)) {
        next.delete(item);
    } else {
        next.add(item);
    }
    return next;
}
